module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_SK-a9ecf089171f63c18eb66cae040d5079.svg";